import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=63aa3a70"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=63aa3a70&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63aa3a70')) {
      api.createRecord('63aa3a70', component.options)
    } else {
      api.reload('63aa3a70', component.options)
    }
    module.hot.accept("./Homepage.vue?vue&type=template&id=63aa3a70", function () {
      api.rerender('63aa3a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/home/Homepage.vue"
export default component.exports